<template>
  <div>
    <div v-if="eventSets.length === 0"
         class="text-secondary text-center small">
      Unsere Reporter melden sich bald mit den ersten Eindrücken vom Spiel.
    </div>
    <div v-else>
      <div v-for="eventSet in eventSets"
           class="row small"
           :key="'eventSet' + eventSets.indexOf(eventSet)">
        <match-event :events="eventSet" :match-report="matchReport"/>
      </div>
    </div>
  </div>
</template>

<script>
import MatchEvent from "@/components/conference/MatchEvent";

export default {
  components: {MatchEvent},
  props: {
    matchReport: Object,
    rawEvents: Array
  },
  computed: {
    eventSets() {
      let res = []
      let lastEvent = undefined
      this.rawEvents.forEach(e => {
        if (!lastEvent || !e.progressable || e.minute != lastEvent.minute || e.half != lastEvent.half) {
          res.push([e])
        } else {
          let eventSet = res[res.length - 1]
          eventSet.unshift(e)
        }
        lastEvent = e
      })
      return res
    }
  }
}
</script>